import { BaseModel } from "sjs-base-model";
import NotaEstimateModel from "stores/note/models/NotaEstimateModel";

export default class NotaOrderModel extends BaseModel {
    public readonly colName?: keyof NotaEstimateModel = "idEstimateRequest";
    public readonly direction?: undefined | "A" | "D" = undefined;

    constructor(data: Partial<NotaOrderModel>) {
        super();

        this.update(data);
    }
}
